import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function render() {
  const els = [
    document.querySelector(".l-about__title"),
    document.querySelector(".l-about__text"),
  ];

  let showContent = gsap.timeline({
    scrollTrigger: {
      end: "top bottom",
      onLeaveBack: () => {
        showContent.reverse();
      },
      scroller: ".smooth-scroll",
      start: "top 35%",
      trigger: ".l-about",
    },
  });
  showContent.to(els, {
    autoAlpha: 1,
    translateX: 0,
  });
}
